var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-container',{staticClass:"pb-0"},[_vm._t("header")],2),_c('div',{staticClass:"body pb-10",class:{ 'gray-background': _vm.gray, 'white-background': !_vm.gray, 'border-top': _vm.borderTop }},[_c('v-container',[_vm._t("body")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }